import _slicedToArray from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator";
import _asyncGeneratorDelegate from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate";
import _awaitAsyncGenerator from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(_syncBatch),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(syncBuffer),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(_syncConcat),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(_syncTake),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(_syncTime);

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

function _batch(_x, _x2) {
  return _batch2.apply(this, arguments);
}

function _batch2() {
  _batch2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(size, iterable) {
    var dataBatch, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dataBatch = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 3;
            _iterator = _asyncIterator(iterable);

          case 5:
            _context.next = 7;
            return _awaitAsyncGenerator(_iterator.next());

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 17;
              break;
            }

            data = _step.value;
            dataBatch.push(data);

            if (!(dataBatch.length === size)) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return dataBatch;

          case 13:
            dataBatch = [];

          case 14:
            _iteratorAbruptCompletion = false;
            _context.next = 5;
            break;

          case 17:
            _context.next = 23;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 23:
            _context.prev = 23;
            _context.prev = 24;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 28;
              break;
            }

            _context.next = 28;
            return _awaitAsyncGenerator(_iterator.return());

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(23);

          case 33:
            if (!(dataBatch.length > 0)) {
              _context.next = 36;
              break;
            }

            _context.next = 36;
            return dataBatch;

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 19, 23, 33], [24,, 28, 32]]);
  }));
  return _batch2.apply(this, arguments);
}

function _syncBatch(size, iterable) {
  var dataBatch, _iterator14, _step14, data;

  return _regeneratorRuntime.wrap(function _syncBatch$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          dataBatch = [];
          _iterator14 = _createForOfIteratorHelper(iterable);
          _context2.prev = 2;

          _iterator14.s();

        case 4:
          if ((_step14 = _iterator14.n()).done) {
            _context2.next = 13;
            break;
          }

          data = _step14.value;
          dataBatch.push(data);

          if (!(dataBatch.length === size)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 10;
          return dataBatch;

        case 10:
          dataBatch = [];

        case 11:
          _context2.next = 4;
          break;

        case 13:
          _context2.next = 18;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](2);

          _iterator14.e(_context2.t0);

        case 18:
          _context2.prev = 18;

          _iterator14.f();

          return _context2.finish(18);

        case 21:
          if (!(dataBatch.length > 0)) {
            _context2.next = 24;
            break;
          }

          _context2.next = 24;
          return dataBatch;

        case 24:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[2, 15, 18, 21]]);
}

function batch(size, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return batch(size, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator]) {
    return _batch(size, iterable);
  }

  return _syncBatch(size, iterable);
}

function getIterator(iterable) {
  if (typeof iterable.next === 'function') {
    return iterable;
  }

  if (typeof iterable[Symbol.iterator] === 'function') {
    return iterable[Symbol.iterator]();
  }

  if (typeof iterable[Symbol.asyncIterator] === 'function') {
    return iterable[Symbol.asyncIterator]();
  }

  throw new TypeError('"values" does not to conform to any of the iterator or iterable protocols');
}

function defer() {
  var reject;
  var resolve;
  var promise = new Promise(function (resolveFunc, rejectFunc) {
    resolve = resolveFunc;
    reject = rejectFunc;
  });
  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
} /// <reference lib="esnext.asynciterable" />


function _buffer(size, iterable) {
  var iterator = getIterator(iterable);
  var resultQueue = [];
  var readQueue = [];
  var reading = false;
  var ended = false;

  function fulfillReadQueue() {
    while (readQueue.length > 0 && resultQueue.length > 0) {
      var readDeferred = readQueue.shift();

      var _resultQueue$shift = resultQueue.shift(),
          error = _resultQueue$shift.error,
          value = _resultQueue$shift.value;

      if (error) {
        readDeferred.reject(error);
      } else {
        readDeferred.resolve({
          done: false,
          value: value
        });
      }
    }

    while (readQueue.length > 0 && ended) {
      var _readQueue$shift = readQueue.shift(),
          resolve = _readQueue$shift.resolve;

      resolve({
        done: true,
        value: undefined
      });
    }
  }

  function fillQueue() {
    return _fillQueue.apply(this, arguments);
  }

  function _fillQueue() {
    _fillQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$iterator$next, done, value;

      return _regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!ended) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              if (!reading) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              if (!(resultQueue.length >= size)) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return");

            case 6:
              reading = true;
              _context3.prev = 7;
              _context3.next = 10;
              return iterator.next();

            case 10:
              _yield$iterator$next = _context3.sent;
              done = _yield$iterator$next.done;
              value = _yield$iterator$next.value;

              if (done) {
                ended = true;
              } else {
                resultQueue.push({
                  value: value
                });
              }

              _context3.next = 20;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](7);
              ended = true;
              resultQueue.push({
                error: _context3.t0
              });

            case 20:
              fulfillReadQueue();
              reading = false;
              fillQueue();

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2, null, [[7, 16]]);
    }));
    return _fillQueue.apply(this, arguments);
  }

  function next() {
    return _next.apply(this, arguments);
  }

  function _next() {
    _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _resultQueue$shift2, error, value, deferred;

      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(resultQueue.length > 0)) {
                _context4.next = 6;
                break;
              }

              _resultQueue$shift2 = resultQueue.shift(), error = _resultQueue$shift2.error, value = _resultQueue$shift2.value;

              if (!error) {
                _context4.next = 4;
                break;
              }

              throw error;

            case 4:
              fillQueue();
              return _context4.abrupt("return", {
                done: false,
                value: value
              });

            case 6:
              if (!ended) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return", {
                done: true,
                value: undefined
              });

            case 8:
              deferred = defer();
              readQueue.push(deferred);
              fillQueue();
              return _context4.abrupt("return", deferred.promise);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3);
    }));
    return _next.apply(this, arguments);
  }

  var asyncIterableIterator = _defineProperty({
    next: next
  }, Symbol.asyncIterator, function () {
    return asyncIterableIterator;
  });

  return asyncIterableIterator;
}

function syncBuffer(size, iterable) {
  var valueQueue, e, _iterator15, _step15, value, _i, _valueQueue, _value;

  return _regeneratorRuntime.wrap(function syncBuffer$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          valueQueue = [];
          _context5.prev = 1;
          _iterator15 = _createForOfIteratorHelper(iterable);
          _context5.prev = 3;

          _iterator15.s();

        case 5:
          if ((_step15 = _iterator15.n()).done) {
            _context5.next = 14;
            break;
          }

          value = _step15.value;
          valueQueue.push(value);

          if (!(valueQueue.length <= size)) {
            _context5.next = 10;
            break;
          }

          return _context5.abrupt("continue", 12);

        case 10:
          _context5.next = 12;
          return valueQueue.shift();

        case 12:
          _context5.next = 5;
          break;

        case 14:
          _context5.next = 19;
          break;

        case 16:
          _context5.prev = 16;
          _context5.t0 = _context5["catch"](3);

          _iterator15.e(_context5.t0);

        case 19:
          _context5.prev = 19;

          _iterator15.f();

          return _context5.finish(19);

        case 22:
          _context5.next = 27;
          break;

        case 24:
          _context5.prev = 24;
          _context5.t1 = _context5["catch"](1);
          e = _context5.t1;

        case 27:
          _i = 0, _valueQueue = valueQueue;

        case 28:
          if (!(_i < _valueQueue.length)) {
            _context5.next = 35;
            break;
          }

          _value = _valueQueue[_i];
          _context5.next = 32;
          return _value;

        case 32:
          _i++;
          _context5.next = 28;
          break;

        case 35:
          if (!e) {
            _context5.next = 37;
            break;
          }

          throw e;

        case 37:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked2, null, [[1, 24], [3, 16, 19, 22]]);
}

function buffer(size, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return buffer(size, curriedIterable);
    };
  }

  if (size === 0) {
    return iterable;
  }

  if (iterable[Symbol.asyncIterator]) {
    return _buffer(size, iterable);
  }

  return syncBuffer(size, iterable);
}

function _collect(_x20) {
  return _collect2.apply(this, arguments);
}

function _collect2() {
  _collect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(iterable) {
    var values, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, value;

    return _regeneratorRuntime.wrap(function _callee23$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            values = [];
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context28.prev = 3;
            _iterator2 = _asyncIterator(iterable);

          case 5:
            _context28.next = 7;
            return _iterator2.next();

          case 7:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context28.sent).done)) {
              _context28.next = 13;
              break;
            }

            value = _step2.value;
            values.push(value);

          case 10:
            _iteratorAbruptCompletion2 = false;
            _context28.next = 5;
            break;

          case 13:
            _context28.next = 19;
            break;

          case 15:
            _context28.prev = 15;
            _context28.t0 = _context28["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context28.t0;

          case 19:
            _context28.prev = 19;
            _context28.prev = 20;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context28.next = 24;
              break;
            }

            _context28.next = 24;
            return _iterator2.return();

          case 24:
            _context28.prev = 24;

            if (!_didIteratorError2) {
              _context28.next = 27;
              break;
            }

            throw _iteratorError2;

          case 27:
            return _context28.finish(24);

          case 28:
            return _context28.finish(19);

          case 29:
            return _context28.abrupt("return", values);

          case 30:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee23, null, [[3, 15, 19, 29], [20,, 24, 28]]);
  }));
  return _collect2.apply(this, arguments);
}

function collect(iterable) {
  if (iterable[Symbol.asyncIterator]) {
    return _collect(iterable);
  }

  return Array.from(iterable);
}

function _concat(_x3) {
  return _concat2.apply(this, arguments);
}

function _concat2() {
  _concat2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(iterables) {
    var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, iterable;

    return _regeneratorRuntime.wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _iteratorAbruptCompletion3 = false;
            _didIteratorError3 = false;
            _context6.prev = 2;
            _iterator3 = _asyncIterator(iterables);

          case 4:
            _context6.next = 6;
            return _awaitAsyncGenerator(_iterator3.next());

          case 6:
            if (!(_iteratorAbruptCompletion3 = !(_step3 = _context6.sent).done)) {
              _context6.next = 12;
              break;
            }

            iterable = _step3.value;
            return _context6.delegateYield(_asyncGeneratorDelegate(_asyncIterator(iterable), _awaitAsyncGenerator), "t0", 9);

          case 9:
            _iteratorAbruptCompletion3 = false;
            _context6.next = 4;
            break;

          case 12:
            _context6.next = 18;
            break;

          case 14:
            _context6.prev = 14;
            _context6.t1 = _context6["catch"](2);
            _didIteratorError3 = true;
            _iteratorError3 = _context6.t1;

          case 18:
            _context6.prev = 18;
            _context6.prev = 19;

            if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
              _context6.next = 23;
              break;
            }

            _context6.next = 23;
            return _awaitAsyncGenerator(_iterator3.return());

          case 23:
            _context6.prev = 23;

            if (!_didIteratorError3) {
              _context6.next = 26;
              break;
            }

            throw _iteratorError3;

          case 26:
            return _context6.finish(23);

          case 27:
            return _context6.finish(18);

          case 28:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee4, null, [[2, 14, 18, 28], [19,, 23, 27]]);
  }));
  return _concat2.apply(this, arguments);
}

function _syncConcat(iterables) {
  var _iterator16, _step16, iterable;

  return _regeneratorRuntime.wrap(function _syncConcat$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _iterator16 = _createForOfIteratorHelper(iterables);
          _context7.prev = 1;

          _iterator16.s();

        case 3:
          if ((_step16 = _iterator16.n()).done) {
            _context7.next = 8;
            break;
          }

          iterable = _step16.value;
          return _context7.delegateYield(iterable, "t0", 6);

        case 6:
          _context7.next = 3;
          break;

        case 8:
          _context7.next = 13;
          break;

        case 10:
          _context7.prev = 10;
          _context7.t1 = _context7["catch"](1);

          _iterator16.e(_context7.t1);

        case 13:
          _context7.prev = 13;

          _iterator16.f();

          return _context7.finish(13);

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked3, null, [[1, 10, 13, 16]]);
}

function concat() {
  for (var _len = arguments.length, iterables = new Array(_len), _key = 0; _key < _len; _key++) {
    iterables[_key] = arguments[_key];
  }

  var hasAnyAsync = iterables.find(function (itr) {
    return itr[Symbol.asyncIterator] !== undefined;
  });

  if (hasAnyAsync) {
    return _concat(iterables);
  } else {
    return _syncConcat(iterables);
  }
}

function _consume(_x21) {
  return _consume2.apply(this, arguments);
}

function _consume2() {
  _consume2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(iterable) {
    var _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, val;

    return _regeneratorRuntime.wrap(function _callee24$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _iteratorAbruptCompletion4 = false;
            _didIteratorError4 = false;
            _context29.prev = 2;
            _iterator4 = _asyncIterator(iterable);

          case 4:
            _context29.next = 6;
            return _iterator4.next();

          case 6:
            if (!(_iteratorAbruptCompletion4 = !(_step4 = _context29.sent).done)) {
              _context29.next = 11;
              break;
            }

            val = _step4.value;

          case 8:
            _iteratorAbruptCompletion4 = false;
            _context29.next = 4;
            break;

          case 11:
            _context29.next = 17;
            break;

          case 13:
            _context29.prev = 13;
            _context29.t0 = _context29["catch"](2);
            _didIteratorError4 = true;
            _iteratorError4 = _context29.t0;

          case 17:
            _context29.prev = 17;
            _context29.prev = 18;

            if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
              _context29.next = 22;
              break;
            }

            _context29.next = 22;
            return _iterator4.return();

          case 22:
            _context29.prev = 22;

            if (!_didIteratorError4) {
              _context29.next = 25;
              break;
            }

            throw _iteratorError4;

          case 25:
            return _context29.finish(22);

          case 26:
            return _context29.finish(17);

          case 27:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee24, null, [[2, 13, 17, 27], [18,, 22, 26]]);
  }));
  return _consume2.apply(this, arguments);
}

function consume(iterable) {
  if (iterable[Symbol.asyncIterator]) {
    return _consume(iterable);
  }

  var _iterator17 = _createForOfIteratorHelper(iterable),
      _step17;

  try {
    for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {// do nothing

      var val = _step17.value;
    }
  } catch (err) {
    _iterator17.e(err);
  } finally {
    _iterator17.f();
  }
}

function _filter(_x4, _x5) {
  return _filter2.apply(this, arguments);
}

function _filter2() {
  _filter2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(filterFunc, iterable) {
    var _iteratorAbruptCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _iteratorAbruptCompletion5 = false;
            _didIteratorError5 = false;
            _context8.prev = 2;
            _iterator5 = _asyncIterator(iterable);

          case 4:
            _context8.next = 6;
            return _awaitAsyncGenerator(_iterator5.next());

          case 6:
            if (!(_iteratorAbruptCompletion5 = !(_step5 = _context8.sent).done)) {
              _context8.next = 16;
              break;
            }

            data = _step5.value;
            _context8.next = 10;
            return _awaitAsyncGenerator(filterFunc(data));

          case 10:
            if (!_context8.sent) {
              _context8.next = 13;
              break;
            }

            _context8.next = 13;
            return data;

          case 13:
            _iteratorAbruptCompletion5 = false;
            _context8.next = 4;
            break;

          case 16:
            _context8.next = 22;
            break;

          case 18:
            _context8.prev = 18;
            _context8.t0 = _context8["catch"](2);
            _didIteratorError5 = true;
            _iteratorError5 = _context8.t0;

          case 22:
            _context8.prev = 22;
            _context8.prev = 23;

            if (!(_iteratorAbruptCompletion5 && _iterator5.return != null)) {
              _context8.next = 27;
              break;
            }

            _context8.next = 27;
            return _awaitAsyncGenerator(_iterator5.return());

          case 27:
            _context8.prev = 27;

            if (!_didIteratorError5) {
              _context8.next = 30;
              break;
            }

            throw _iteratorError5;

          case 30:
            return _context8.finish(27);

          case 31:
            return _context8.finish(22);

          case 32:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee5, null, [[2, 18, 22, 32], [23,, 27, 31]]);
  }));
  return _filter2.apply(this, arguments);
}

function filter(filterFunc, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _filter(filterFunc, curriedIterable);
    };
  }

  return _filter(filterFunc, iterable);
}

function flatten(_x6) {
  return _flatten.apply(this, arguments);
}

function _flatten() {
  _flatten = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(iterable) {
    var _iteratorAbruptCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, maybeItr;

    return _regeneratorRuntime.wrap(function _callee6$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _iteratorAbruptCompletion6 = false;
            _didIteratorError6 = false;
            _context9.prev = 2;
            _iterator6 = _asyncIterator(iterable);

          case 4:
            _context9.next = 6;
            return _awaitAsyncGenerator(_iterator6.next());

          case 6:
            if (!(_iteratorAbruptCompletion6 = !(_step6 = _context9.sent).done)) {
              _context9.next = 17;
              break;
            }

            maybeItr = _step6.value;

            if (!(maybeItr && typeof maybeItr !== 'string' && (maybeItr[Symbol.iterator] || maybeItr[Symbol.asyncIterator]))) {
              _context9.next = 12;
              break;
            }

            return _context9.delegateYield(_asyncGeneratorDelegate(_asyncIterator(flatten(maybeItr)), _awaitAsyncGenerator), "t0", 10);

          case 10:
            _context9.next = 14;
            break;

          case 12:
            _context9.next = 14;
            return maybeItr;

          case 14:
            _iteratorAbruptCompletion6 = false;
            _context9.next = 4;
            break;

          case 17:
            _context9.next = 23;
            break;

          case 19:
            _context9.prev = 19;
            _context9.t1 = _context9["catch"](2);
            _didIteratorError6 = true;
            _iteratorError6 = _context9.t1;

          case 23:
            _context9.prev = 23;
            _context9.prev = 24;

            if (!(_iteratorAbruptCompletion6 && _iterator6.return != null)) {
              _context9.next = 28;
              break;
            }

            _context9.next = 28;
            return _awaitAsyncGenerator(_iterator6.return());

          case 28:
            _context9.prev = 28;

            if (!_didIteratorError6) {
              _context9.next = 31;
              break;
            }

            throw _iteratorError6;

          case 31:
            return _context9.finish(28);

          case 32:
            return _context9.finish(23);

          case 33:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee6, null, [[2, 19, 23, 33], [24,, 28, 32]]);
  }));
  return _flatten.apply(this, arguments);
}

function _map(_x7, _x8) {
  return _map2.apply(this, arguments);
}

function _map2() {
  _map2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(func, iterable) {
    var _iteratorAbruptCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, val;

    return _regeneratorRuntime.wrap(function _callee7$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _iteratorAbruptCompletion7 = false;
            _didIteratorError7 = false;
            _context10.prev = 2;
            _iterator7 = _asyncIterator(iterable);

          case 4:
            _context10.next = 6;
            return _awaitAsyncGenerator(_iterator7.next());

          case 6:
            if (!(_iteratorAbruptCompletion7 = !(_step7 = _context10.sent).done)) {
              _context10.next = 15;
              break;
            }

            val = _step7.value;
            _context10.next = 10;
            return _awaitAsyncGenerator(func(val));

          case 10:
            _context10.next = 12;
            return _context10.sent;

          case 12:
            _iteratorAbruptCompletion7 = false;
            _context10.next = 4;
            break;

          case 15:
            _context10.next = 21;
            break;

          case 17:
            _context10.prev = 17;
            _context10.t0 = _context10["catch"](2);
            _didIteratorError7 = true;
            _iteratorError7 = _context10.t0;

          case 21:
            _context10.prev = 21;
            _context10.prev = 22;

            if (!(_iteratorAbruptCompletion7 && _iterator7.return != null)) {
              _context10.next = 26;
              break;
            }

            _context10.next = 26;
            return _awaitAsyncGenerator(_iterator7.return());

          case 26:
            _context10.prev = 26;

            if (!_didIteratorError7) {
              _context10.next = 29;
              break;
            }

            throw _iteratorError7;

          case 29:
            return _context10.finish(26);

          case 30:
            return _context10.finish(21);

          case 31:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee7, null, [[2, 17, 21, 31], [22,, 26, 30]]);
  }));
  return _map2.apply(this, arguments);
}

function map(func, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _map(func, curriedIterable);
    };
  }

  return _map(func, iterable);
}

function flatMap(func, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return flatMap(func, curriedIterable);
    };
  }

  return filter(function (i) {
    return i !== undefined && i !== null;
  }, flatten(map(func, iterable)));
}

function _flatTransform(concurrency, func, iterable) {
  var iterator = getIterator(iterable);
  var resultQueue = [];
  var readQueue = [];
  var ended = false;
  var reading = false;
  var inflightCount = 0;
  var lastError = null;

  function fulfillReadQueue() {
    while (readQueue.length > 0 && resultQueue.length > 0) {
      var _readQueue$shift2 = readQueue.shift(),
          resolve = _readQueue$shift2.resolve;

      var value = resultQueue.shift();
      resolve({
        done: false,
        value: value
      });
    }

    while (readQueue.length > 0 && inflightCount === 0 && ended) {
      var _readQueue$shift3 = readQueue.shift(),
          _resolve = _readQueue$shift3.resolve,
          reject = _readQueue$shift3.reject;

      if (lastError) {
        reject(lastError);
        lastError = null;
      } else {
        _resolve({
          done: true,
          value: undefined
        });
      }
    }
  }

  function fillQueue() {
    return _fillQueue2.apply(this, arguments);
  }

  function _fillQueue2() {
    _fillQueue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _yield$iterator$next2, done, value;

      return _regeneratorRuntime.wrap(function _callee8$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!ended) {
                _context11.next = 3;
                break;
              }

              fulfillReadQueue();
              return _context11.abrupt("return");

            case 3:
              if (!reading) {
                _context11.next = 5;
                break;
              }

              return _context11.abrupt("return");

            case 5:
              if (!(inflightCount + resultQueue.length >= concurrency)) {
                _context11.next = 7;
                break;
              }

              return _context11.abrupt("return");

            case 7:
              reading = true;
              inflightCount++;
              _context11.prev = 9;
              _context11.next = 12;
              return iterator.next();

            case 12:
              _yield$iterator$next2 = _context11.sent;
              done = _yield$iterator$next2.done;
              value = _yield$iterator$next2.value;

              if (done) {
                ended = true;
                inflightCount--;
                fulfillReadQueue();
              } else {
                mapAndQueue(value);
              }

              _context11.next = 24;
              break;

            case 18:
              _context11.prev = 18;
              _context11.t0 = _context11["catch"](9);
              ended = true;
              inflightCount--;
              lastError = _context11.t0;
              fulfillReadQueue();

            case 24:
              reading = false;
              fillQueue();

            case 26:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee8, null, [[9, 18]]);
    }));
    return _fillQueue2.apply(this, arguments);
  }

  function mapAndQueue(_x22) {
    return _mapAndQueue.apply(this, arguments);
  }

  function _mapAndQueue() {
    _mapAndQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(itrValue) {
      var value, _iteratorAbruptCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, asyncVal;

      return _regeneratorRuntime.wrap(function _callee9$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return func(itrValue);

            case 3:
              value = _context12.sent;

              if (!(value && value[Symbol.asyncIterator])) {
                _context12.next = 35;
                break;
              }

              _iteratorAbruptCompletion8 = false;
              _didIteratorError8 = false;
              _context12.prev = 7;
              _iterator8 = _asyncIterator(value);

            case 9:
              _context12.next = 11;
              return _iterator8.next();

            case 11:
              if (!(_iteratorAbruptCompletion8 = !(_step8 = _context12.sent).done)) {
                _context12.next = 17;
                break;
              }

              asyncVal = _step8.value;
              resultQueue.push(asyncVal);

            case 14:
              _iteratorAbruptCompletion8 = false;
              _context12.next = 9;
              break;

            case 17:
              _context12.next = 23;
              break;

            case 19:
              _context12.prev = 19;
              _context12.t0 = _context12["catch"](7);
              _didIteratorError8 = true;
              _iteratorError8 = _context12.t0;

            case 23:
              _context12.prev = 23;
              _context12.prev = 24;

              if (!(_iteratorAbruptCompletion8 && _iterator8.return != null)) {
                _context12.next = 28;
                break;
              }

              _context12.next = 28;
              return _iterator8.return();

            case 28:
              _context12.prev = 28;

              if (!_didIteratorError8) {
                _context12.next = 31;
                break;
              }

              throw _iteratorError8;

            case 31:
              return _context12.finish(28);

            case 32:
              return _context12.finish(23);

            case 33:
              _context12.next = 36;
              break;

            case 35:
              resultQueue.push(value);

            case 36:
              _context12.next = 42;
              break;

            case 38:
              _context12.prev = 38;
              _context12.t1 = _context12["catch"](0);
              ended = true;
              lastError = _context12.t1;

            case 42:
              inflightCount--;
              fulfillReadQueue();
              fillQueue();

            case 45:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee9, null, [[0, 38], [7, 19, 23, 33], [24,, 28, 32]]);
    }));
    return _mapAndQueue.apply(this, arguments);
  }

  function next() {
    return _next2.apply(this, arguments);
  }

  function _next2() {
    _next2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var deferred, value;
      return _regeneratorRuntime.wrap(function _callee10$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!(resultQueue.length === 0)) {
                _context13.next = 5;
                break;
              }

              deferred = defer();
              readQueue.push(deferred);
              fillQueue();
              return _context13.abrupt("return", deferred.promise);

            case 5:
              value = resultQueue.shift();
              fillQueue();
              return _context13.abrupt("return", {
                done: false,
                value: value
              });

            case 8:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee10);
    }));
    return _next2.apply(this, arguments);
  }

  var asyncIterableIterator = _defineProperty({
    next: next
  }, Symbol.asyncIterator, function () {
    return asyncIterableIterator;
  });

  return asyncIterableIterator;
}

function flatTransform(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return curriedIterable ? flatTransform(concurrency, curriedFunc, curriedIterable) : flatTransform(concurrency, curriedFunc);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return flatTransform(concurrency, func, curriedIterable);
    };
  }

  return filter(function (i) {
    return i !== undefined && i !== null;
  }, flatten(_flatTransform(concurrency, func, iterable)));
}

function onceReadable(_x23) {
  return _onceReadable.apply(this, arguments);
}

function _onceReadable() {
  _onceReadable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(stream) {
    return _regeneratorRuntime.wrap(function _callee25$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            return _context30.abrupt("return", new Promise(function (resolve) {
              stream.once('readable', function () {
                resolve();
              });
            }));

          case 1:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee25);
  }));
  return _onceReadable.apply(this, arguments);
}

function _fromStream(_x9) {
  return _fromStream2.apply(this, arguments);
}

function _fromStream2() {
  _fromStream2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(stream) {
    var data;
    return _regeneratorRuntime.wrap(function _callee11$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!true) {
              _context14.next = 12;
              break;
            }

            data = stream.read();

            if (!(data !== null)) {
              _context14.next = 6;
              break;
            }

            _context14.next = 5;
            return data;

          case 5:
            return _context14.abrupt("continue", 0);

          case 6:
            if (!stream._readableState.ended) {
              _context14.next = 8;
              break;
            }

            return _context14.abrupt("break", 12);

          case 8:
            _context14.next = 10;
            return _awaitAsyncGenerator(onceReadable(stream));

          case 10:
            _context14.next = 0;
            break;

          case 12:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee11);
  }));
  return _fromStream2.apply(this, arguments);
}

function fromStream(stream) {
  if (typeof stream[Symbol.asyncIterator] === 'function') {
    return stream;
  }

  return _fromStream(stream);
}

function merge() {
  return _merge.apply(this, arguments);
}

function _merge() {
  _merge = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var _len2,
        iterables,
        _key2,
        sources,
        _iterator18,
        _step18,
        iterator,
        nextVal,
        _args15 = arguments;

    return _regeneratorRuntime.wrap(function _callee12$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            for (_len2 = _args15.length, iterables = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              iterables[_key2] = _args15[_key2];
            }

            sources = new Set(iterables.map(getIterator));

          case 2:
            if (!(sources.size > 0)) {
              _context15.next = 29;
              break;
            }

            _iterator18 = _createForOfIteratorHelper(sources);
            _context15.prev = 4;

            _iterator18.s();

          case 6:
            if ((_step18 = _iterator18.n()).done) {
              _context15.next = 19;
              break;
            }

            iterator = _step18.value;
            _context15.next = 10;
            return _awaitAsyncGenerator(iterator.next());

          case 10:
            nextVal = _context15.sent;

            if (!nextVal.done) {
              _context15.next = 15;
              break;
            }

            sources.delete(iterator);
            _context15.next = 17;
            break;

          case 15:
            _context15.next = 17;
            return nextVal.value;

          case 17:
            _context15.next = 6;
            break;

          case 19:
            _context15.next = 24;
            break;

          case 21:
            _context15.prev = 21;
            _context15.t0 = _context15["catch"](4);

            _iterator18.e(_context15.t0);

          case 24:
            _context15.prev = 24;

            _iterator18.f();

            return _context15.finish(24);

          case 27:
            _context15.next = 2;
            break;

          case 29:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee12, null, [[4, 21, 24, 27]]);
  }));
  return _merge.apply(this, arguments);
}

function pipeline(firstFn) {
  var previousFn = firstFn();

  for (var _len3 = arguments.length, fns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    fns[_key3 - 1] = arguments[_key3];
  }

  for (var _i2 = 0, _fns = fns; _i2 < _fns.length; _i2++) {
    var func = _fns[_i2];
    previousFn = func(previousFn);
  }

  return previousFn;
}

function _parallelMap(_x10, _x11, _x12) {
  return _parallelMap2.apply(this, arguments);
}

function _parallelMap2() {
  _parallelMap2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(concurrency, func, iterable) {
    var transformError, wrapFunc, stopOnError, output, itr, _yield$_awaitAsyncGen, value, done, val;

    return _regeneratorRuntime.wrap(function _callee14$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            transformError = null;

            wrapFunc = function wrapFunc(value) {
              return {
                value: func(value)
              };
            };

            stopOnError = /*#__PURE__*/function () {
              var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(source) {
                var _iteratorAbruptCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, value;

                return _regeneratorRuntime.wrap(function _callee13$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        _iteratorAbruptCompletion13 = false;
                        _didIteratorError13 = false;
                        _context16.prev = 2;
                        _iterator13 = _asyncIterator(source);

                      case 4:
                        _context16.next = 6;
                        return _awaitAsyncGenerator(_iterator13.next());

                      case 6:
                        if (!(_iteratorAbruptCompletion13 = !(_step13 = _context16.sent).done)) {
                          _context16.next = 15;
                          break;
                        }

                        value = _step13.value;

                        if (!transformError) {
                          _context16.next = 10;
                          break;
                        }

                        return _context16.abrupt("return");

                      case 10:
                        _context16.next = 12;
                        return value;

                      case 12:
                        _iteratorAbruptCompletion13 = false;
                        _context16.next = 4;
                        break;

                      case 15:
                        _context16.next = 21;
                        break;

                      case 17:
                        _context16.prev = 17;
                        _context16.t0 = _context16["catch"](2);
                        _didIteratorError13 = true;
                        _iteratorError13 = _context16.t0;

                      case 21:
                        _context16.prev = 21;
                        _context16.prev = 22;

                        if (!(_iteratorAbruptCompletion13 && _iterator13.return != null)) {
                          _context16.next = 26;
                          break;
                        }

                        _context16.next = 26;
                        return _awaitAsyncGenerator(_iterator13.return());

                      case 26:
                        _context16.prev = 26;

                        if (!_didIteratorError13) {
                          _context16.next = 29;
                          break;
                        }

                        throw _iteratorError13;

                      case 29:
                        return _context16.finish(26);

                      case 30:
                        return _context16.finish(21);

                      case 31:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee13, null, [[2, 17, 21, 31], [22,, 26, 30]]);
              }));

              return function stopOnError(_x19) {
                return _ref.apply(this, arguments);
              };
            }();

            output = pipeline(function () {
              return iterable;
            }, buffer(1), stopOnError, map(wrapFunc), buffer(concurrency - 1));
            itr = getIterator(output);

          case 5:
            if (!true) {
              _context17.next = 27;
              break;
            }

            _context17.next = 8;
            return _awaitAsyncGenerator(itr.next());

          case 8:
            _yield$_awaitAsyncGen = _context17.sent;
            value = _yield$_awaitAsyncGen.value;
            done = _yield$_awaitAsyncGen.done;

            if (!done) {
              _context17.next = 13;
              break;
            }

            return _context17.abrupt("break", 27);

          case 13:
            _context17.prev = 13;
            _context17.next = 16;
            return _awaitAsyncGenerator(value.value);

          case 16:
            val = _context17.sent;

            if (transformError) {
              _context17.next = 20;
              break;
            }

            _context17.next = 20;
            return val;

          case 20:
            _context17.next = 25;
            break;

          case 22:
            _context17.prev = 22;
            _context17.t0 = _context17["catch"](13);
            transformError = _context17.t0;

          case 25:
            _context17.next = 5;
            break;

          case 27:
            if (!transformError) {
              _context17.next = 29;
              break;
            }

            throw transformError;

          case 29:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee14, null, [[13, 22]]);
  }));
  return _parallelMap2.apply(this, arguments);
}

function parallelMap(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return parallelMap(concurrency, curriedFunc, curriedIterable);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return parallelMap(concurrency, func, curriedIterable);
    };
  }

  if (concurrency === 1) {
    return map(func, iterable);
  }

  return _parallelMap(concurrency, func, iterable);
}

function parallelFlatMap(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return curriedIterable ? parallelFlatMap(concurrency, curriedFunc, curriedIterable) : parallelFlatMap(concurrency, curriedFunc);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return parallelFlatMap(concurrency, func, curriedIterable);
    };
  }

  return filter(function (i) {
    return i !== undefined && i !== null;
  }, flatten(parallelMap(concurrency, func, iterable)));
} /// <reference lib="esnext.asynciterable" />


function parallelMerge() {
  return _parallelMerge.apply(this, arguments);
}

function _parallelMerge() {
  _parallelMerge = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var _len4,
        iterables,
        _key4,
        inputs,
        concurrentWork,
        values,
        lastError,
        errCb,
        valueCb,
        notifyError,
        notifyDone,
        waitForQueue,
        queueNext,
        _iterator19,
        _step19,
        _input,
        _iterator20,
        _step20,
        _step20$value,
        input,
        value,
        _args19 = arguments;

    return _regeneratorRuntime.wrap(function _callee16$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            for (_len4 = _args19.length, iterables = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              iterables[_key4] = _args19[_key4];
            }

            inputs = iterables.map(getIterator);
            concurrentWork = new Set();
            values = new Map();
            lastError = null;
            errCb = null;
            valueCb = null;

            notifyError = function notifyError(err) {
              lastError = err;

              if (errCb) {
                errCb(err);
              }
            };

            notifyDone = function notifyDone(value) {
              if (valueCb) {
                valueCb(value);
              }
            };

            waitForQueue = function waitForQueue() {
              return new Promise(function (resolve, reject) {
                if (lastError) {
                  reject(lastError);
                }

                if (values.size > 0) {
                  return resolve();
                }

                valueCb = resolve;
                errCb = reject;
              });
            };

            queueNext = function queueNext(input) {
              var nextVal = Promise.resolve(input.next()).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref2) {
                  var done, value;
                  return _regeneratorRuntime.wrap(function _callee15$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          done = _ref2.done, value = _ref2.value;

                          if (!done) {
                            values.set(input, value);
                          }

                          concurrentWork.delete(nextVal);

                        case 3:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee15);
                }));

                return function (_x24) {
                  return _ref3.apply(this, arguments);
                };
              }());
              concurrentWork.add(nextVal);
              nextVal.then(notifyDone, notifyError);
            };

            _iterator19 = _createForOfIteratorHelper(inputs);

            try {
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                _input = _step19.value;
                queueNext(_input);
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }

          case 13:
            if (!true) {
              _context19.next = 39;
              break;
            }

            if (!(concurrentWork.size === 0 && values.size === 0)) {
              _context19.next = 16;
              break;
            }

            return _context19.abrupt("return");

          case 16:
            _context19.next = 18;
            return _awaitAsyncGenerator(waitForQueue());

          case 18:
            _iterator20 = _createForOfIteratorHelper(values);
            _context19.prev = 19;

            _iterator20.s();

          case 21:
            if ((_step20 = _iterator20.n()).done) {
              _context19.next = 29;
              break;
            }

            _step20$value = _slicedToArray(_step20.value, 2), input = _step20$value[0], value = _step20$value[1];
            values.delete(input);
            _context19.next = 26;
            return value;

          case 26:
            queueNext(input);

          case 27:
            _context19.next = 21;
            break;

          case 29:
            _context19.next = 34;
            break;

          case 31:
            _context19.prev = 31;
            _context19.t0 = _context19["catch"](19);

            _iterator20.e(_context19.t0);

          case 34:
            _context19.prev = 34;

            _iterator20.f();

            return _context19.finish(34);

          case 37:
            _context19.next = 13;
            break;

          case 39:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee16, null, [[19, 31, 34, 37]]);
  }));
  return _parallelMerge.apply(this, arguments);
}

function _reduce(_x25, _x26, _x27) {
  return _reduce2.apply(this, arguments);
}

function _reduce2() {
  _reduce2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(func, start, iterable) {
    var value, _iteratorAbruptCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, nextItem;

    return _regeneratorRuntime.wrap(function _callee26$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            value = start;
            _iteratorAbruptCompletion9 = false;
            _didIteratorError9 = false;
            _context31.prev = 3;
            _iterator9 = _asyncIterator(iterable);

          case 5:
            _context31.next = 7;
            return _iterator9.next();

          case 7:
            if (!(_iteratorAbruptCompletion9 = !(_step9 = _context31.sent).done)) {
              _context31.next = 15;
              break;
            }

            nextItem = _step9.value;
            _context31.next = 11;
            return func(value, nextItem);

          case 11:
            value = _context31.sent;

          case 12:
            _iteratorAbruptCompletion9 = false;
            _context31.next = 5;
            break;

          case 15:
            _context31.next = 21;
            break;

          case 17:
            _context31.prev = 17;
            _context31.t0 = _context31["catch"](3);
            _didIteratorError9 = true;
            _iteratorError9 = _context31.t0;

          case 21:
            _context31.prev = 21;
            _context31.prev = 22;

            if (!(_iteratorAbruptCompletion9 && _iterator9.return != null)) {
              _context31.next = 26;
              break;
            }

            _context31.next = 26;
            return _iterator9.return();

          case 26:
            _context31.prev = 26;

            if (!_didIteratorError9) {
              _context31.next = 29;
              break;
            }

            throw _iteratorError9;

          case 29:
            return _context31.finish(26);

          case 30:
            return _context31.finish(21);

          case 31:
            return _context31.abrupt("return", value);

          case 32:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee26, null, [[3, 17, 21, 31], [22,, 26, 30]]);
  }));
  return _reduce2.apply(this, arguments);
}

function reduce(func, start, iterable) {
  if (start === undefined) {
    return function (curriedStart, curriedIterable) {
      return curriedIterable ? _reduce(func, curriedStart, curriedIterable) : reduce(func, curriedStart);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return reduce(func, start, curriedIterable);
    };
  }

  return _reduce(func, start, iterable);
}

function _take(_x13, _x14) {
  return _take2.apply(this, arguments);
}

function _take2() {
  _take2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(count, iterable) {
    var taken, _iteratorAbruptCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, val;

    return _regeneratorRuntime.wrap(function _callee17$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            taken = 0;
            _iteratorAbruptCompletion10 = false;
            _didIteratorError10 = false;
            _context20.prev = 3;
            _iterator10 = _asyncIterator(iterable);

          case 5:
            _context20.next = 7;
            return _awaitAsyncGenerator(_iterator10.next());

          case 7:
            if (!(_iteratorAbruptCompletion10 = !(_step10 = _context20.sent).done)) {
              _context20.next = 19;
              break;
            }

            val = _step10.value;
            _context20.next = 11;
            return _awaitAsyncGenerator(val);

          case 11:
            _context20.next = 13;
            return _context20.sent;

          case 13:
            taken++;

            if (!(taken >= count)) {
              _context20.next = 16;
              break;
            }

            return _context20.abrupt("break", 19);

          case 16:
            _iteratorAbruptCompletion10 = false;
            _context20.next = 5;
            break;

          case 19:
            _context20.next = 25;
            break;

          case 21:
            _context20.prev = 21;
            _context20.t0 = _context20["catch"](3);
            _didIteratorError10 = true;
            _iteratorError10 = _context20.t0;

          case 25:
            _context20.prev = 25;
            _context20.prev = 26;

            if (!(_iteratorAbruptCompletion10 && _iterator10.return != null)) {
              _context20.next = 30;
              break;
            }

            _context20.next = 30;
            return _awaitAsyncGenerator(_iterator10.return());

          case 30:
            _context20.prev = 30;

            if (!_didIteratorError10) {
              _context20.next = 33;
              break;
            }

            throw _iteratorError10;

          case 33:
            return _context20.finish(30);

          case 34:
            return _context20.finish(25);

          case 35:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee17, null, [[3, 21, 25, 35], [26,, 30, 34]]);
  }));
  return _take2.apply(this, arguments);
}

function _syncTake(count, iterable) {
  var taken, _iterator21, _step21, val;

  return _regeneratorRuntime.wrap(function _syncTake$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          taken = 0;
          _iterator21 = _createForOfIteratorHelper(iterable);
          _context21.prev = 2;

          _iterator21.s();

        case 4:
          if ((_step21 = _iterator21.n()).done) {
            _context21.next = 13;
            break;
          }

          val = _step21.value;
          _context21.next = 8;
          return val;

        case 8:
          taken++;

          if (!(taken >= count)) {
            _context21.next = 11;
            break;
          }

          return _context21.abrupt("break", 13);

        case 11:
          _context21.next = 4;
          break;

        case 13:
          _context21.next = 18;
          break;

        case 15:
          _context21.prev = 15;
          _context21.t0 = _context21["catch"](2);

          _iterator21.e(_context21.t0);

        case 18:
          _context21.prev = 18;

          _iterator21.f();

          return _context21.finish(18);

        case 21:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked4, null, [[2, 15, 18, 21]]);
}

function take(count, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return take(count, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator]) {
    return _take(count, iterable);
  }

  return _syncTake(count, iterable);
}

function _asyncTap(_x15, _x16) {
  return _asyncTap2.apply(this, arguments);
}

function _asyncTap2() {
  _asyncTap2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(func, iterable) {
    var _iteratorAbruptCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, val;

    return _regeneratorRuntime.wrap(function _callee18$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _iteratorAbruptCompletion11 = false;
            _didIteratorError11 = false;
            _context22.prev = 2;
            _iterator11 = _asyncIterator(iterable);

          case 4:
            _context22.next = 6;
            return _awaitAsyncGenerator(_iterator11.next());

          case 6:
            if (!(_iteratorAbruptCompletion11 = !(_step11 = _context22.sent).done)) {
              _context22.next = 15;
              break;
            }

            val = _step11.value;
            _context22.next = 10;
            return _awaitAsyncGenerator(func(val));

          case 10:
            _context22.next = 12;
            return val;

          case 12:
            _iteratorAbruptCompletion11 = false;
            _context22.next = 4;
            break;

          case 15:
            _context22.next = 21;
            break;

          case 17:
            _context22.prev = 17;
            _context22.t0 = _context22["catch"](2);
            _didIteratorError11 = true;
            _iteratorError11 = _context22.t0;

          case 21:
            _context22.prev = 21;
            _context22.prev = 22;

            if (!(_iteratorAbruptCompletion11 && _iterator11.return != null)) {
              _context22.next = 26;
              break;
            }

            _context22.next = 26;
            return _awaitAsyncGenerator(_iterator11.return());

          case 26:
            _context22.prev = 26;

            if (!_didIteratorError11) {
              _context22.next = 29;
              break;
            }

            throw _iteratorError11;

          case 29:
            return _context22.finish(26);

          case 30:
            return _context22.finish(21);

          case 31:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee18, null, [[2, 17, 21, 31], [22,, 26, 30]]);
  }));
  return _asyncTap2.apply(this, arguments);
}

function tap(func, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _asyncTap(func, curriedIterable);
    };
  }

  return _asyncTap(func, iterable);
}

function addTime(a, b) {
  var seconds = a[0] + b[0];
  var nanoseconds = a[1] + b[1];

  if (nanoseconds >= 1000000000) {
    var remainder = nanoseconds % 1000000000;
    seconds += (nanoseconds - remainder) / 1000000000;
    nanoseconds = remainder;
  }

  return [seconds, nanoseconds];
}

function _asyncTime(_x17, _x18) {
  return _asyncTime2.apply(this, arguments);
}

function _asyncTime2() {
  _asyncTime2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(config, iterable) {
    var itr, total, start, _yield$_awaitAsyncGen2, value, done, delta;

    return _regeneratorRuntime.wrap(function _callee19$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            itr = iterable[Symbol.asyncIterator]();
            total = [0, 0];

          case 2:
            if (!true) {
              _context23.next = 19;
              break;
            }

            start = process.hrtime();
            _context23.next = 6;
            return _awaitAsyncGenerator(itr.next());

          case 6:
            _yield$_awaitAsyncGen2 = _context23.sent;
            value = _yield$_awaitAsyncGen2.value;
            done = _yield$_awaitAsyncGen2.done;
            delta = process.hrtime(start);
            total = addTime(total, delta);

            if (config.progress) {
              config.progress(delta, total);
            }

            if (!done) {
              _context23.next = 15;
              break;
            }

            if (config.total) {
              config.total(total);
            }

            return _context23.abrupt("return", value);

          case 15:
            _context23.next = 17;
            return value;

          case 17:
            _context23.next = 2;
            break;

          case 19:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee19);
  }));
  return _asyncTime2.apply(this, arguments);
}

function _syncTime(config, iterable) {
  var itr, total, start, _itr$next, value, done, delta;

  return _regeneratorRuntime.wrap(function _syncTime$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          itr = iterable[Symbol.iterator]();
          total = [0, 0];

        case 2:
          if (!true) {
            _context24.next = 15;
            break;
          }

          start = process.hrtime();
          _itr$next = itr.next(), value = _itr$next.value, done = _itr$next.done;
          delta = process.hrtime(start);
          total = addTime(total, delta);

          if (config.progress) {
            config.progress(delta, total);
          }

          if (!done) {
            _context24.next = 11;
            break;
          }

          if (config.total) {
            config.total(total);
          }

          return _context24.abrupt("return", value);

        case 11:
          _context24.next = 13;
          return value;

        case 13:
          _context24.next = 2;
          break;

        case 15:
        case "end":
          return _context24.stop();
      }
    }
  }, _marked5);
}

function time() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var iterable = arguments.length > 1 ? arguments[1] : undefined;

  if (iterable === undefined) {
    return function (curriedIterable) {
      return time(config, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator] !== undefined) {
    return _asyncTime(config, iterable);
  } else {
    return _syncTime(config, iterable);
  }
}

function _transform(concurrency, func, iterable) {
  var iterator = getIterator(iterable);
  var resultQueue = [];
  var readQueue = [];
  var ended = false;
  var reading = false;
  var inflightCount = 0;
  var lastError = null;

  function fulfillReadQueue() {
    while (readQueue.length > 0 && resultQueue.length > 0) {
      var _readQueue$shift4 = readQueue.shift(),
          resolve = _readQueue$shift4.resolve;

      var value = resultQueue.shift();
      resolve({
        done: false,
        value: value
      });
    }

    while (readQueue.length > 0 && inflightCount === 0 && ended) {
      var _readQueue$shift5 = readQueue.shift(),
          _resolve2 = _readQueue$shift5.resolve,
          reject = _readQueue$shift5.reject;

      if (lastError) {
        reject(lastError);
        lastError = null;
      } else {
        _resolve2({
          done: true,
          value: undefined
        });
      }
    }
  }

  function fillQueue() {
    return _fillQueue3.apply(this, arguments);
  }

  function _fillQueue3() {
    _fillQueue3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      var _yield$iterator$next3, done, value;

      return _regeneratorRuntime.wrap(function _callee20$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              if (!ended) {
                _context25.next = 3;
                break;
              }

              fulfillReadQueue();
              return _context25.abrupt("return");

            case 3:
              if (!reading) {
                _context25.next = 5;
                break;
              }

              return _context25.abrupt("return");

            case 5:
              if (!(inflightCount + resultQueue.length >= concurrency)) {
                _context25.next = 7;
                break;
              }

              return _context25.abrupt("return");

            case 7:
              reading = true;
              inflightCount++;
              _context25.prev = 9;
              _context25.next = 12;
              return iterator.next();

            case 12:
              _yield$iterator$next3 = _context25.sent;
              done = _yield$iterator$next3.done;
              value = _yield$iterator$next3.value;

              if (done) {
                ended = true;
                inflightCount--;
                fulfillReadQueue();
              } else {
                mapAndQueue(value);
              }

              _context25.next = 24;
              break;

            case 18:
              _context25.prev = 18;
              _context25.t0 = _context25["catch"](9);
              ended = true;
              inflightCount--;
              lastError = _context25.t0;
              fulfillReadQueue();

            case 24:
              reading = false;
              fillQueue();

            case 26:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee20, null, [[9, 18]]);
    }));
    return _fillQueue3.apply(this, arguments);
  }

  function mapAndQueue(_x28) {
    return _mapAndQueue2.apply(this, arguments);
  }

  function _mapAndQueue2() {
    _mapAndQueue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(itrValue) {
      var value;
      return _regeneratorRuntime.wrap(function _callee21$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return func(itrValue);

            case 3:
              value = _context26.sent;
              resultQueue.push(value);
              _context26.next = 11;
              break;

            case 7:
              _context26.prev = 7;
              _context26.t0 = _context26["catch"](0);
              ended = true;
              lastError = _context26.t0;

            case 11:
              inflightCount--;
              fulfillReadQueue();
              fillQueue();

            case 14:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee21, null, [[0, 7]]);
    }));
    return _mapAndQueue2.apply(this, arguments);
  }

  function next() {
    return _next3.apply(this, arguments);
  }

  function _next3() {
    _next3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
      var deferred, value;
      return _regeneratorRuntime.wrap(function _callee22$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              if (!(resultQueue.length === 0)) {
                _context27.next = 5;
                break;
              }

              deferred = defer();
              readQueue.push(deferred);
              fillQueue();
              return _context27.abrupt("return", deferred.promise);

            case 5:
              value = resultQueue.shift();
              fillQueue();
              return _context27.abrupt("return", {
                done: false,
                value: value
              });

            case 8:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee22);
    }));
    return _next3.apply(this, arguments);
  }

  var asyncIterableIterator = _defineProperty({
    next: next
  }, Symbol.asyncIterator, function () {
    return asyncIterableIterator;
  });

  return asyncIterableIterator;
}

function transform(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return curriedIterable ? transform(concurrency, curriedFunc, curriedIterable) : transform(concurrency, curriedFunc);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return transform(concurrency, func, curriedIterable);
    };
  }

  return _transform(concurrency, func, iterable);
}

function _writeToStream(_x29, _x30) {
  return _writeToStream2.apply(this, arguments);
}

function _writeToStream2() {
  _writeToStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(stream, iterable) {
    var lastError, errCb, drainCb, notifyError, notifyDrain, cleanup, waitForDrain, _iteratorAbruptCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, value;

    return _regeneratorRuntime.wrap(function _callee27$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            lastError = null;
            errCb = null;
            drainCb = null;

            notifyError = function notifyError(err) {
              lastError = err;

              if (errCb) {
                errCb(err);
              }
            };

            notifyDrain = function notifyDrain() {
              if (drainCb) {
                drainCb();
              }
            };

            cleanup = function cleanup() {
              stream.removeListener('error', notifyError);
              stream.removeListener('drain', notifyDrain);
            };

            stream.once('error', notifyError);

            waitForDrain = function waitForDrain() {
              return new Promise(function (resolve, reject) {
                if (lastError) {
                  return reject(lastError);
                }

                stream.once('drain', notifyDrain);
                drainCb = resolve;
                errCb = reject;
              });
            };

            _iteratorAbruptCompletion12 = false;
            _didIteratorError12 = false;
            _context32.prev = 10;
            _iterator12 = _asyncIterator(iterable);

          case 12:
            _context32.next = 14;
            return _iterator12.next();

          case 14:
            if (!(_iteratorAbruptCompletion12 = !(_step12 = _context32.sent).done)) {
              _context32.next = 24;
              break;
            }

            value = _step12.value;

            if (!(stream.write(value) === false)) {
              _context32.next = 19;
              break;
            }

            _context32.next = 19;
            return waitForDrain();

          case 19:
            if (!lastError) {
              _context32.next = 21;
              break;
            }

            return _context32.abrupt("break", 24);

          case 21:
            _iteratorAbruptCompletion12 = false;
            _context32.next = 12;
            break;

          case 24:
            _context32.next = 30;
            break;

          case 26:
            _context32.prev = 26;
            _context32.t0 = _context32["catch"](10);
            _didIteratorError12 = true;
            _iteratorError12 = _context32.t0;

          case 30:
            _context32.prev = 30;
            _context32.prev = 31;

            if (!(_iteratorAbruptCompletion12 && _iterator12.return != null)) {
              _context32.next = 35;
              break;
            }

            _context32.next = 35;
            return _iterator12.return();

          case 35:
            _context32.prev = 35;

            if (!_didIteratorError12) {
              _context32.next = 38;
              break;
            }

            throw _iteratorError12;

          case 38:
            return _context32.finish(35);

          case 39:
            return _context32.finish(30);

          case 40:
            cleanup();

            if (!lastError) {
              _context32.next = 43;
              break;
            }

            throw lastError;

          case 43:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee27, null, [[10, 26, 30, 40], [31,, 35, 39]]);
  }));
  return _writeToStream2.apply(this, arguments);
}

function writeToStream(stream, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _writeToStream(stream, curriedIterable);
    };
  }

  return _writeToStream(stream, iterable);
}

export { batch, buffer, collect, concat, consume, filter, flatMap, flatTransform, flatten, fromStream, getIterator, map, merge, parallelFlatMap, parallelMap, parallelMerge, pipeline, reduce, take, tap, time, transform, writeToStream };